//html Elements
var floorPlan = document.getElementById('floorPlan');

//svg elements
var floorPlanMap;
var floorPlanMapHighlights = [
  '6AHighlighted',
  '6BHighlighted',
  '7Highlighted',
  '8Highlighted',
  '9Highlighted',
  '10Highlighted',
  '11Highlighted',
  '12Highlighted',
  '13Highlighted',
  '14Highlighted',
  '15Highlighted',
  '16Highlighted',
];

//arrows
var previousArrows, nextArrows;

//array of all availabilities from wordpress
var availabilitiesArray = [];
var currentAvailabilityIndex = 0;
var availabilitiesCount;

//if block exisits - init
if (floorPlan) {
  //get reference to svg
  floorPlanMap = document.getElementById('floorPlanMap');
  setupArrows();
  setupSVG();
  updateArrowStyling();
  initilizeDefaultState();
}

function setupSVG() {
  dimSVGFloor();

  //floors not in an availability are treated as unavailable.
  //get list of all floors and remove the unavailable svg layer from floorMapSVG
  var floorsAvailable = [];
  availabilitiesArray.map((availability) => {
    //for each availability
    availability.floors.map((floor) => {
      //for each floor associated with availability
      floorsAvailable.indexOf(floor) === -1
        ? floorsAvailable.push(floor)
        : console.log('');
    });
  });

  markFloorsAsAvailable(floorsAvailable);
}

//svg inherintly marks floors as unavailble.
//upon init - This file gather a list of all floors referenced in availabilities and makes unavailble layer as hidden to show "available" layer below
function markFloorsAsAvailable(floorsAvailable) {
  floorsAvailable.map((floor) => {
    switch (floor) {
      case 'L': //lower floor has 3 sections - so we need the ID's for all of them
        floorPlanMap.getElementById('LLeftUnavailable').style.opacity = 0;
        floorPlanMap.getElementById('LRightUnavailable').style.opacity = 0;
        floorPlanMap.getElementById('LCenterUnavailable').style.opacity = 0;
        break;
      default:
        floorPlanMap.getElementById(floor + 'Unavailable').style.opacity = 0;
    }
  });
}

function dimSVGFloor() {
  //hides highlights to start. these highlights will be dynamically turned on depending on the activeAvailability
  floorPlanMapHighlights.map((highlight) => {
    floorPlanMap.getElementById(highlight).style.opacity = 0;
  });
}

function initilizeDefaultState() {
  hightlightFloorFromAvailability(availabilitiesArray[0]);
}

//adds click listeners to all previous and next arrow buttons. we needed a few to accomodate designs at varous media brekapoints
function setupArrows() {
  //attach click listeners to all previous and next buttons
  previousArrows = floorPlan.querySelectorAll('.previousAvailabilityButton');
  previousArrows.forEach((previousArrow) => {
    previousArrow.addEventListener('click', previousAvailability);
  });
  nextArrows = floorPlan.querySelectorAll('.nextAvailabilityButton');
  nextArrows.forEach((nextArrow) => {
    nextArrow.addEventListener('click', nextAvailability);
  });
}

//select previous floor
function previousAvailability() {
  // console.log("previous amenity");
  //iterate index and ensure it does not go below min (0)
  currentAvailabilityIndex = currentAvailabilityIndex - 1;
  if (currentAvailabilityIndex < 0) {
    currentAvailabilityIndex = 0;
  }
  updateFrontEnd();
}

//select next floor
function nextAvailability() {
  // console.log("next amenity");
  //iterate index and ensure it does not go above the amount of availabilities (0)
  currentAvailabilityIndex = currentAvailabilityIndex + 1;
  if (currentAvailabilityIndex > availabilitiesCount) {
    currentAvailabilityIndex = availabilitiesCount;
  }
  updateFrontEnd();
}

//updates visible text info, arrow stlying and svg active highlights
function updateFrontEnd() {
  updateArrowStyling();
  dimSVGFloor();
  hightlightFloorFromAvailability(
    availabilitiesArray[currentAvailabilityIndex]
  );
}

function updateArrowStyling() {
  switch (currentAvailabilityIndex) {
    case 0: //fade out previous arrow if at min (0)
      previousArrows.forEach((previousArrow) => {
        previousArrow.style.opacity = 0.4;
        previousArrow.style.pointerEvents = 'none';
      });
      break;
    case availabilitiesCount: //fade our next arrow if at max (number of availabilities passed)
      nextArrows.forEach((nextArrow) => {
        nextArrow.style.opacity = 0.4;
        nextArrow.style.pointerEvents = 'none';
      });
      break;
    default:
      previousArrows.forEach((previousArrow) => {
        previousArrow.style.opacity = 1.0;
        previousArrow.style.pointerEvents = 'auto';
      });
      nextArrows.forEach((nextArrow) => {
        nextArrow.style.opacity = 1.0;
        nextArrow.style.pointerEvents = 'auto';
      });
  }
}

//highlights floors based on the array passed
function hightlightFloorFromAvailability(availability) {
  availability.floors.map((floor) => {
    // for each floor associated with floor
    var floorIDs = getFloorHighlightIDs(floor); //returns array of svg element id's associated with the floor
    floorIDs.map((id) => {
      floorPlanMap.getElementById(id).style.opacity = 1.0; // set svg element to visible
    });
  });
}

function getFloorHighlightIDs(floor) {
  var floorIDs = [];
  switch (floor) {
    case '6': //lower floor has 3 sections - so we need the ID's for all of them
      floorIDs.push(floor + 'AHighlighted');
      floorIDs.push(floor + 'BHighlighted');
      break;
    default:
      floorIDs.push(floor + 'Highlighted');
  }
  return floorIDs;
}
